import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Phone, ChevronDown } from 'lucide-react';
import { companyInfo } from '../mock';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from './ui/sheet';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import './Header.css';

const SHOP_URL = 'https://shop.avk-pro.ru/sport';
const CABINET_URL = 'https://avik.site/rodkom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Соцсети
  const vkUrl = 'https://vk.com/avk_sport_spb';
  const tgUrl = 'https://t.me/avk_sport';

  const closeMenu = () => setMobileMenuOpen(false);

  return (
    <header className="avk-home-header avk-header-sticky">
      <div className="avk-home-header-inner">
        <Link to="/" aria-label="AVK SPORT — главная">
          <img src="/logo-white.png" alt="AVK SPORT" width="132" height="44" />
        </Link>

        {/* Десктоп-навигация */}
        <nav aria-label="Основное меню" className="avk-home-nav">
          <Link to="/catalog">Каталог</Link>
          <Link to="/about">Производство</Link>
          <Link to="/contacts">Контакты</Link>
          <DropdownMenu modal={false}>
            <DropdownMenuTrigger className="avk-dropdown-trigger" aria-label="О нас — подменю">
              О нас <ChevronDown size={14} strokeWidth={2} aria-hidden="true" />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" sideOffset={12} className="avk-dropdown-content">
              <DropdownMenuItem asChild>
                <Link to="/about" className="avk-dropdown-item">О компании</Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/reviews" className="avk-dropdown-item">Отзывы</Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/blog" className="avk-dropdown-item">Блог</Link>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </nav>

        {/* Кнопки справа (десктоп) / «Кабинет родкома» + бургер (мобайл) */}
        <div className="avk-home-actions">
          <a className="avk-home-shop" href={SHOP_URL}>Магазин клуба ↗</a>
          <a className="avk-home-cabinet" href={CABINET_URL}>Кабинет родкома</a>
          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
            <SheetTrigger asChild>
              <button className="avk-home-menu" aria-label="Открыть меню"><Menu size={24} /></button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-ink text-white">
              <SheetHeader>
                <SheetTitle className="text-white">AVK SPORT</SheetTitle>
              </SheetHeader>
              <nav className="avk-home-mobile-nav" aria-label="Мобильное меню">
                <a href={CABINET_URL} onClick={closeMenu} className="avk-mobile-cabinet">Кабинет родкома</a>
                <Link to="/catalog" onClick={closeMenu}>Каталог</Link>
                <Link to="/about" onClick={closeMenu}>Производство</Link>
                <Link to="/contacts" onClick={closeMenu}>Контакты</Link>
                <span className="avk-mobile-group" aria-hidden="true">О нас</span>
                <Link to="/about" onClick={closeMenu} className="avk-mobile-sub">О компании</Link>
                <Link to="/reviews" onClick={closeMenu} className="avk-mobile-sub">Отзывы</Link>
                <Link to="/blog" onClick={closeMenu} className="avk-mobile-sub">Блог</Link>
                <a href={SHOP_URL} onClick={closeMenu}>Магазин клуба ↗</a>
                <a href={`tel:${companyInfo.phone.replace(/[^+\d]/g, '')}`} className="avk-mobile-phone">
                  <Phone size={16} strokeWidth={1.5} aria-hidden="true" /> {companyInfo.phone}
                </a>
                <span className="avk-mobile-socials">
                  <a href={vkUrl} target="_blank" rel="noopener noreferrer">ВКонтакте</a>
                  <a href={tgUrl} target="_blank" rel="noopener noreferrer">Telegram</a>
                </span>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;
